import {Modal} from "react-bootstrap";
import MDButton from "../../../components/MDButton";

export default function Preview({previewTitle, previewContent, showPreview, handleClose}) {

  return (
    <Modal onHide={handleClose} size={'xl'} show={showPreview}>
      <Modal.Header closeButton>
        <Modal.Title>Preview - {previewTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div
          dangerouslySetInnerHTML={{__html: previewContent}}
        />
      </Modal.Body>
      <Modal.Footer>
        <MDButton type="button" color="info" onClick={() => {
          handleClose()
        }}>
          Close
        </MDButton>
      </Modal.Footer>
    </Modal>
  );
}